import fridge from '../assets/images/fridge.webp'
import React from 'react';
import mesh from '../assets/images/mesh.svg'
import { scroolToElement } from './utils/scrollTo';

export const Intro = () => {
    return (
        <main className="container row mx-auto d-flex align-items-center  extra-margin  p-0 ">
            <div data-aos="fade-up" className="col-12 col-lg-6 p-0 text-center text-lg-start mt-5 mt-md-0">
                <h1 className='intro-text-color display-3'>Chytrá lednice</h1>
                <p className='text-white opacity-75 my-3 intro-desc'>s řízeným odběrem produktům, online
                    <br />  skladovým systémem  a automatizovaným <br />  prodejem 24/7.</p>
                <div className='extra-bottom-margin'>
                    <button onClick={() => scroolToElement("firstSection")} id='send-button' className='mx-auto mx-lg-0'>
                        <span>Zjistit více</span>
                        <div className='liquid'></div>
                    </button>
                </div>
            </div>
            <div className="col-12 col-lg-6 ">
                <div style={{ backgroundImage: `url(${mesh})` }} data-aos="fade-left" className="fridge-circle rounded-circle mx-auto">
                    <img src={fridge} alt="chytrá lednice pickit" />
                </div>
            </div>
        </main>
    )
}